import { render, staticRenderFns } from "./cobros_recibos_banco.vue?vue&type=template&id=3e35cc60&"
import script from "./cobros_recibos_banco.vue?vue&type=script&lang=js&"
export * from "./cobros_recibos_banco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports